<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-header class="title">
      <mat-card-title class="no-subtitle"
        >Phone number not available</mat-card-title
      >
      <button
        mat-icon-button
        color="primary"
        (click)="dialog.closeAll()"
        tabindex="-1"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>

    <mat-card-content>
      @if (data === MsgType.Individual) {
        <p>This pilot does not have a public phone number listed with APA.</p>
      }
      @if (data === MsgType.GroupText) {
        <p>
          One or more pilots do not have a public phone number listed with APA.
        </p>
      }
    </mat-card-content>
  </mat-card>
</div>
